import { PropsWithChildren } from 'react';

const Spinner = ({ size }: PropsWithChildren<{ size: string }>) => {
  return (<i className="pi pi-spin pi-spinner text-primary-500" style={{ 'fontSize': size }}/>);
};

export default Spinner;